import { useState } from "react";
import { doc, updateDoc, increment } from "firebase/firestore";
import { db } from "../../modules/auth/firebaseConfig";

export default function ActionBar({ postId, likes, userId }) {
  const [liked, setLiked] = useState(false);

  const handleLike = async () => {
    setLiked(!liked);
    await updateDoc(doc(db, "posts", postId), {
      likes: increment(liked ? -1 : 1),
    });
  };

  return (
    <div className="absolute right-4 bottom-16 flex flex-col items-center space-y-6">

      <div onClick={handleLike} className="cursor-pointer">
        {liked ? "❤️" : "🤍"}
        <p className="text-xs">{likes}</p>
      </div>

      <div className="cursor-pointer">
        💬
        <p className="text-xs">Comment</p>
      </div>

      <div className="cursor-pointer">
        🔁
        <p className="text-xs">Share</p>
      </div>

      <div className="cursor-pointer">
        ➕
        <p className="text-xs">Follow</p>
      </div>
    </div>
  );
}
